export default {
  metrics: {
    go_lives: 'Totaal go-lives',
    avg_quality_score: 'Gemiddelde kwaliteitsscore',
    managers: {
      title: 'Onboardingmanagers',
      fields: {
        name: 'Naam manager',
        go_lives: 'Go-lives',
        avg_quality_score: 'Gem. kwaliteitsscore',
      },
    },
  },
  details: {
    name: 'Restaurant',
    owner: 'Naam eigenaar',
    owner_phone: 'Telefoonnummer eigenaar',
    owner_email: 'E-mail eigenaar',
    live_from: 'Go-live datum',
    onboarding_manager: 'Onboardingmanager',
    sales_manager: 'Salesmanager',
    onboarding_quality_score: 'Kwaliteitsscore',
    export_csv: 'CSV exporteren',
  },
};
